import { Routes } from '@angular/router';
import { LoginFailedComponent } from './login-failed/login-failed.component';
import { HomePageComponent } from './home-page/home-page.component';
import { SearchPageComponent } from './search-page/search-page.component';
import { DossiersPageComponent } from './dossiers-page/dossiers-page.component';
import { DossierPageComponent } from './dossier-page/dossier-page.component';
import { DossierStatsPageComponent } from './dossier-stats-page/dossier-stats-page.component';
import { StagingAreaPageComponent } from './staging-area-page/staging-area-page.component';
import { MsalGuard } from '@azure/msal-angular';
import { AdminPageComponent } from './admin-page/admin-page.component';

export const routes: Routes = [
	{ path: 'login-failed', component: LoginFailedComponent },
	{ path: '', component: HomePageComponent, canActivate: [MsalGuard] },
	{
		path: 'search',
		component: SearchPageComponent,
		canActivate: [MsalGuard],
	},
	{
		path: 'dossiers',
		component: DossiersPageComponent,
		canActivate: [MsalGuard],
	},
	{
		path: 'dossier',
		component: DossierPageComponent,
		canActivate: [MsalGuard],
	},
	{
		path: 'dossier-stats',
		component: DossierStatsPageComponent,
		canActivate: [MsalGuard],
	},
	{
		path: 'staging-area',
		component: StagingAreaPageComponent,
		canActivate: [MsalGuard],
	},
	{
		path: 'admin',
		component: AdminPageComponent,
		canActivate: [MsalGuard],
	},
];
